export const QUILL_MODULES = {
	toolbar: [
		['bold', 'italic', 'underline', 'strike'],
		[{ list: 'ordered' }, { list: 'bullet' }],
		['link', 'blockquote', 'code-block'],
		['clean'],
	],
};

export const QUILL_FORMATS = [
	'bold',
	'italic',
	'underline',
	'strike',
	'list',
	'bullet',
	'link',
	'blockquote',
	'code-block',
];

/** Toolbar/formats for inbox-style emails (signatures, logos, etc.). */
export const QUILL_EMAIL_TOOLBAR = [
	['bold', 'italic', 'underline', 'strike'],
	[{ color: [] }],
	[{ list: 'ordered' }, { list: 'bullet' }],
	['link', 'image', 'blockquote'],
	['clean'],
];

export const QUILL_EMAIL_FORMATS = [...QUILL_FORMATS, 'image', 'color'];

export const RICH_TEXT_SX = {
	p: { margin: 0, lineHeight: 1.6 },
	'p + p': { mt: 2 },
	a: { color: 'orange.500', textDecoration: 'underline' },
	'ul, ol': { paddingLeft: '20px' },
	img: {
		maxWidth: '280px',
		height: 'auto',
		display: 'inline-block',
		my: 2,
		borderRadius: '4px',
	},
	blockquote: {
		borderLeft: '3px solid',
		borderColor: 'gray.300',
		pl: 3,
		color: 'gray.600',
		my: 2,
	},
	code: { bg: 'gray.100', px: 1, borderRadius: '3px', fontSize: '12px' },
	pre: {
		bg: 'gray.900',
		color: 'gray.100',
		p: 2,
		borderRadius: 'md',
		fontSize: '12px',
		overflowX: 'auto',
	},
};

export const stripRichText = (html) => {
	if (!html) return '';
	return String(html)
		.replace(/<[^>]*>/g, '')
		.replace(/&nbsp;/g, ' ')
		.trim();
};

export const isRichTextEmpty = (html) => {
	if (!html) return true;
	if (/<img\b/i.test(String(html))) return false;
	return stripRichText(html).length === 0;
};
